import {
  chakra,
  forwardRef,
  ThemingProps,
  omitThemingProps,
  useStyleConfig,
  HTMLChakraProps,
  keyframes,
} from '@chakra-ui/react';
import { __DEV__ } from '@chakra-ui/utils';

const bounce = keyframes`
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
`;

export interface ICircleLoaderProps extends HTMLChakraProps<'div'>, ThemingProps {}

export const CircleLoader = forwardRef<ICircleLoaderProps, 'div'>(function CircleLoader(props, ref) {
  const styles = useStyleConfig('CircleLoader', props);

  const {
    // extract components props here
    ...rest
  } = omitThemingProps(props);

  const componentStyles = {
    position: 'relative',

    '&::before, &::after': {
      content: '""',

      position: 'absolute',
      top: '0',
      left: '0',

      width: '100%',
      height: '100%',
      borderRadius: '50%',

      backgroundColor: 'currentColor',

      animation: `${bounce} 2s infinite ease-in-out`,
    },

    '&::before': {
      opacity: '0.6',
    },

    '&::after': {
      opacity: '0.7',

      animationDelay: '-1s',
    },
    ...styles,
  };

  return <chakra.div ref={ref} __css={componentStyles} {...rest} />;
});

if (__DEV__) {
  CircleLoader.displayName = 'CircleLoader';
}
